<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <template v-if="sort === 'asc'">
      <path
        d="M4.14964 0H2.96331L0.0584661 8.29949H1.70976L2.14616 7.05262H4.93405L5.36421 8.29949H7.01292L4.14964 0ZM2.69167 5.49402L3.55011 3.04125L4.39636 5.49402H2.69167Z"
        :fill="color"
      />
      <path
        d="M18.8784 14.0552L15.9171 17.0166V0H14.3585V17.0166L11.3972 14.0552L10.2951 15.1573L15.1378 20L19.9805 15.1573L18.8784 14.0552Z"
        :fill="color"
      />
      <path
        d="M7.11109 11.6894H0.0195312V13.248H4.76719L0.0195312 18.7646V19.989H7.03316V18.4304H2.36344L7.11109 12.9138V11.6894Z"
        :fill="color"
      />
    </template>
    <template v-else-if="sort === 'desc'">
      <path
        d="M4.14964 0H2.96331L0.0584661 8.29949H1.70976L2.14616 7.05262H4.93405L5.36421 8.29949H7.01292L4.14964 0ZM2.69167 5.49402L3.55011 3.04125L4.39636 5.49402H2.69167Z"
        :fill="color"
      />
      <path
        d="M11.3972 5.94477L14.3585 2.98344V20H15.9171V2.98344L18.8784 5.94477L19.9805 4.8427L15.1378 0L10.2951 4.8427L11.3972 5.94477Z"
        :fill="color"
      />
      <path
        d="M7.11109 11.6894H0.0195312V13.248H4.76719L0.0195312 18.7646V19.989H7.03316V18.4304H2.36344L7.11109 12.9138V11.6894Z"
        :fill="color"
      />
    </template>
    <template v-else>
      <path
        d="M4.14964 0H2.96331L0.0584661 8.29949H1.70976L2.14616 7.05262H4.93405L5.36421 8.29949H7.01292L4.14964 0ZM2.69167 5.49402L3.55011 3.04125L4.39636 5.49402H2.69167Z"
        :fill="color"
      />
      <path
        d="M15.9171 17.0166L18.8784 14.0552L19.9805 15.1573L15.1378 20L10.2951 15.1573L11.3972 14.0552L14.3585 17.0166V6H15.9171V17.0166Z"
        :fill="color"
      />
      <path
        d="M14.3585 2.98344L11.3972 5.94477L10.2951 4.8427L15.1378 0L19.9805 4.8427L18.8784 5.94477L15.9171 2.98344V14H14.3585V2.98344Z"
        :fill="color"
      />
      <path
        d="M7.11109 11.6894H0.0195312V13.248H4.76719L0.0195312 18.7646V19.989H7.03316V18.4304H2.36344L7.11109 12.9138V11.6894Z"
        :fill="color"
      />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'IconSortAlphabetical',
  props: {
    sort: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    size: {
      type: [Number, String],
      default: 20,
    },
  },
}
</script>
